import * as React from "react";
import type { SVGProps } from "react";
const SvgEarningstodayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="earningstoday_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 512a341.333 341.333 0 1 1 182.528 302.208 42.667 42.667 0 0 0-39.766 75.52A424.96 424.96 0 0 0 512 938.667c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512c0 63.147 13.739 123.136 38.4 177.152a42.667 42.667 0 0 0 73.942 6.528l145.792-97.195 96.853 64.598a42.667 42.667 0 0 0 53.845-5.334l241.067-241.066a42.667 42.667 0 0 0-30.165-72.832H584.533a42.667 42.667 0 0 0 0 85.333h17.494L458.58 572.672l-91.434-60.97a42.667 42.667 0 0 0-47.36 0l-136.875 91.306A341.76 341.76 0 0 1 170.667 512z"
    />
  </svg>
);
export default SvgEarningstodayIcon;
